import React, { useState, useEffect, useRef } from "react";
import "./Before.css";

import Title from "../../shared/ui/Title/title";

function Before() {
  const [openItems, setOpenItems] = useState({});
  const sectionRef = useRef(null);
  const itemsRef = useRef([]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible");
          }
        });
      },
      { threshold: 0.2, rootMargin: "0px" }
    );

    itemsRef.current.forEach((item) => {
      if (item) observer.observe(item);
    });

    return () => observer.disconnect();
  }, []);

  const toggleItem = (index) => {
    setOpenItems(prev => ({
      ...prev,
      [index]: !prev[index]
    }));
  };

  const faqItems = [
    {
      question: "Какой бенто торт заказать для двоих?",
      answer: "Бенто торт диаметром 12 см и весом 500 гр идеально подойдет для 2-х человек. Это самый популярный выбор для романтического вечера или маленького праздника.",
      icon: "💑",
      category: "Бенто торты"
    },
    {
      question: "Какой бенто торт заказать для большой компании?",
      answer: "Бенто-MAXI диаметром 14 см и весом 1 кг отлично подойдет для компании 3-5 человек. Это увеличенная версия классического бенто торта.",
      icon: "🎉",
      category: "Бенто торты"
    },
    {
      question: "Как рассчитать вес торта?",
      answer: "Бисквитные торты от 1.5 кг и диаметром 18 см подойдут на компанию 5-8 человек. Для более точного расчета: стандартная порция на человека — 150-200 грамм.",
      icon: "⚖️",
      category: "Расчет веса"
    },
    {
      question: "Какой вес торта заказать для компании?",
      answer: "Исходите из расчета 150-200 гр на человека. Для компании из 10 человек оптимальный вес торта — 1.5-2 кг. Для детей порция меньше — 100-150 гр.",
      icon: "👥",
      category: "Расчет веса"
    }
  ];

  return (
    <section className="before" id="Before" ref={sectionRef}>
      {/* Декоративные элементы */}
      <div className="before-decoration">
        <div className="decoration-circle"></div>
        <div className="decoration-dots"></div>
      </div>

      <div className="before-container">
        <Title title="Часто задаваемые вопросы" translate="F.A.Q." />
        
        <div className="before-content">
          {/* Категории/фильтры (можно добавить позже) */}
          {/* <div className="faq-categories">
            <span className="category active">Все вопросы</span>
            <span className="category">Бенто торты</span>
            <span className="category">Расчет веса</span>
          </div> */}

          {/* FAQ список */}
          <div className="faq-list">
            {faqItems.map((item, index) => (
              <div
                key={index}
                className={`faq-item ${openItems[index] ? 'open' : ''}`}
                ref={el => itemsRef.current[index] = el}
              >
                <div 
                  className="faq-question"
                  onClick={() => toggleItem(index)}
                >
                  <div className="question-content">
                    <span className="faq-icon">{item.icon}</span>
                    <div className="question-text">
                      <span className="faq-category-tag">{item.category}</span>
                      <h3 className="faq-question-title">{item.question}</h3>
                    </div>
                  </div>
                  <button className="faq-toggle">
                    <span className="toggle-line"></span>
                    <span className="toggle-line"></span>
                  </button>
                </div>
                
                <div className="faq-answer">
                  <div className="answer-content">
                    <p className="faq-answer-text">{item.answer}</p>
                    <div className="answer-decoration">
                      <span className="dots"></span>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Дополнительная информация */}
          <div className="faq-footer">
            <p className="footer-text">
              Остались вопросы? Свяжитесь со мной для консультации!
            </p>
            <a href="#Order" className="footer-button">
              Задать вопрос
              <span className="button-arrow">→</span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Before;